const numericCollator = new Intl.Collator(undefined, { numeric: true, sensitivity: 'base' });

// Trims before comparing: a leading space outweighs the numeric run that follows it, so
// `"  77"` would sort before `"8"`. Writes are trimmed too, this keeps rows written before
// that — or through a path that bypasses the schema — in the right place.
export function compareNumericStrings(a?: string | null, b?: string | null): number {
  return numericCollator.compare((a ?? '').trim(), (b ?? '').trim());
}
